import React from 'react';
import {Provider} from 'react-redux';

import {EDTContext} from './context';

import store from '.';

import type {ReactNode as Node} from 'react';

type Props = {
    children: Node,
};

export const DesignToolProvider = ({children}: Props) => (
    <Provider store={store} context={EDTContext}>
        {children}
    </Provider>
);
